import { render, staticRenderFns } from "./BenefitInvoicesDetailsModal.vue?vue&type=template&id=7c04098e"
import script from "./BenefitInvoicesDetailsModal.vue?vue&type=script&lang=js"
export * from "./BenefitInvoicesDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports